export default "/images/fe312edc09a2982f921938599a39d207.avif";